/* eslint react/forbid-prop-types: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import {
  extend,
  bool as boolType,
  arrayOf,
  shape as shapeType,
  string as stringType,
  number as numberType
} from '@thd-nucleus/data-sources';
import {
  ProductPod,
  ProductBadge,
  ProductImage, PodSection, PodSpacer, PodFooter
} from '@thd-olt-component-react/product-pod';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { Button } from '@one-thd/sui-atomic-components';
import { Price } from '@thd-olt-component-react/price';

export const ListRecsPod = ({
  itemId,
  podIndex,
  storeId,
  onIntentResolved,
  bundleFlag,
  bundleItems
}) => {
  return (
    <div data-component="ListRecsPod">
      <ProductPod
        itemId={itemId}
        storeId={storeId}
        analyticsData={{
          parent: 'product-list', position: podIndex
        }}
        render={(pod) => (
          <>
            <div className="sui-grid sui-grid-cols-7 sui-gap-1">
              <div className="sui-col-span-3">
                <PodSection padding="sui-p-0" noPadding columnAlign relative>
                  <PodSpacer padding={['BOTTOM', 'RIGHT']}>
                    <PodSpacer padding={['BOTTOM']}>
                      <ProductBadge itemId={pod.itemId} storeId={storeId} />
                    </PodSpacer>
                    <ProductImage itemId={pod.itemId} />
                  </PodSpacer>
                </PodSection>
              </div>
              <div className="sui-col-span-4">
                <ProductHeader
                  brand="inline"
                  itemId={pod.itemId}
                  brandTitleMaxLine={3}
                  disableShopThisCollection
                />
                <PodSpacer padding={['TOP', 'BOTTOM']}>
                  <Price
                    itemId={pod.itemId}
                    storeId={storeId}
                    large={false}
                    type="simple"
                    hideBadge
                    hideWhenZero
                    hideBulkPrice
                    hideLimitPerOrder
                    hideSavingsText
                    hidePromotions
                    stackWasPrice
                    omitDetails
                  />
                </PodSpacer>

              </div>
            </div>
            <PodFooter>
              <Button
                onClick={() => {
                  const itemIds = bundleFlag && bundleItems
                    ? bundleItems.map((item) => item.id)
                    : [pod.itemId];
                  onIntentResolved({ itemIds });
                }}
                fullWidth
                variant="secondary"
              >Confirm
              </Button>
            </PodFooter>
          </>
        )}
      />
    </div>
  );
};

ListRecsPod.displayName = 'ListRecsPod';

ListRecsPod.propTypes = {
  itemId: PropTypes.string.isRequired,
  podIndex: PropTypes.number,
  storeId: PropTypes.string,
  onIntentResolved: PropTypes.func.isRequired,
  bundleFlag: PropTypes.bool,
  bundleItems: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    quantity: PropTypes.number
  }))
};

ListRecsPod.defaultProps = {
  podIndex: 1,
  storeId: '',
  bundleFlag: null,
  bundleItems: null
};

ListRecsPod.dataModel = extend(
  {
    product: extend(
      ProductPod.dataModel.product,
      {
        bundleFlag: boolType(),
        bundleItems: arrayOf(shapeType({
          id: stringType(),
          quantity: numberType()
        }))
      }
    )
  },
  ProductImage,
  Price
);
